import React, { FC, createContext, useContext, useMemo } from 'react';

import type { AppContextType } from '../types';

type AppContextWithoutRelay = Omit<AppContextType, 'relay'>;
type RelayWithoutEnvironment = Omit<AppContextType['relay'], 'environment'>;

export interface LazyRelayAppWrapperProps extends AppContextWithoutRelay {
  readonly relay: RelayWithoutEnvironment;
}

/* istanbul ignore next */
export const LazyRelayAppWrapper: FC<LazyRelayAppWrapperProps> = ({
  children,
  getExperimentTreatment,
  isFeatureEnabled,
  relay,
  loki,
  currentLocale,
}) => {
  const environment = useMemo(
    async () =>
      (await import(/* webpackChunkName: "4-feat-relay" */ '../environment')).createRelayEnvironment({
        ...relay,
        isFeatureEnabled,
      }),
    [relay]
  );

  const appContext = useMemo(
    () => ({
      relay: {
        ...relay,
        environment,
      },
      loki,
      getExperimentTreatment,
      isFeatureEnabled,
      currentLocale,
    }),
    [environment, relay, loki, currentLocale]
  );

  return <AppContext.Provider value={appContext}>{children}</AppContext.Provider>;
};

/* istanbul ignore next */
const acquireToken = () => Promise.resolve('');
/* istanbul ignore next */
const isFeatureEnabled = () => true;
/* istanbul ignore next */
const getExperimentTreatment = () => '';
/* istanbul ignore next */
const currentLocale = 'en-US';
export const AppContext = createContext<AppContextType>({
  relay: {
    environment: undefined,
    acquireToken,
    host: '',
  },
  loki: {
    acquireToken,
    clientType: '',
    region: '',
  },
  getExperimentTreatment,
  isFeatureEnabled,
  currentLocale,
});

/* istanbul ignore next */
export const useAppContext = () => useContext(AppContext);
